import styled from 'styled-components';
import { theme } from '../../../configuration';

const FormContainer = styled.div`
  background-color: ${theme.colours.formBackground};
  border: 1px solid ${theme.colours.border};
  border-radius: 7px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 10px;
`;

export default FormContainer;

